import { ObservableArray, View } from "binder"
import { AuthenticationViewModel } from "./authentication-viewModel"

export class AuthenticationView extends View<AuthenticationViewModel>{
    GetViewUniqueId(): string {
        return "V-E48E50A6-3423-4059-86FD-C19F01ACBC13"
    }
    loadHtml(): string {
        let element = require('./authentication.html').default;
        let style = require('./authentication.less');
        return element;
    }
    constructor() {
       super();
    }

    public set username(v: string) { this._username = v; } public get username(): string { return this._username;} private _username: string;
    public set password(v: string) { this._password = v; } public get password(): string { return this._password;} private _password: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isPasswordWrong(v: boolean) { this._isPasswordWrong = v; } public get isPasswordWrong(): boolean { return this._isPasswordWrong;} private _isPasswordWrong: boolean;

    public set browserCompatibilityIssues(v: string) { this._browserCompatibilityIssues = v; } public get browserCompatibilityIssues(): string { return this._browserCompatibilityIssues;} private _browserCompatibilityIssues: string;
    public set hasCompatibilityIssues(v: boolean) { this._hasCompatibilityIssues = v; } public get hasCompatibilityIssues(): boolean { return this._hasCompatibilityIssues;} private _hasCompatibilityIssues: boolean;
    
    async login(){
        this.dataContext.login();
    }
}
